var React = require('react');

function Exclamation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M12 7.5V12.75","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25Z","fill":"currentColor","key":2})]);
}

Exclamation.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = Exclamation;

Exclamation.default = Exclamation;
